import { useEffect } from "react";

import DynamicQueryParams from "./DynamicQueryParams";
import SwitchOptions from "./SwitchOptions";

import useProductEmbedStore from "../useProductEmbedStore";

const Iframe = ({
  updateCustomization,
  otherCustomizations,
  customization,
}) => {
  const { isQueryParamsEnabled } = useProductEmbedStore.pick();

  useEffect(() => {
    if (isQueryParamsEnabled) return;
    updateCustomization({ queryParams: undefined });
  }, []);

  return (
    <>
      {otherCustomizations()}
      <SwitchOptions {...{ customization, updateCustomization }} />
      {isQueryParamsEnabled && (
        <DynamicQueryParams {...{ updateCustomization }} />
      )}
    </>
  );
};
export default Iframe;
